import numeral from 'numeral';

const LETTERS = [
  {letter: 't', divide: 1000000000000},
  {letter: 'b', divide: 1000000000},
  {letter: 'm', divide: 1000000},
  {letter: 'k', divide: 1000}
];

const abbreviateForChart = (num) => {
  // format numbers for y-axes.
  // tried to find a library for this, but nothing did exactly what I needed
  if (num < 1000) { return num.toString(); }
  const { letter, divide } = LETTERS.find((obj) => (num / obj.divide) >= 1);
  return `${num / divide}${letter}`;
};

/**
 * Adds commas and abbreviations to numbers (or strings) where needed.
 * @param {integer|float|string} num The variable that needs commas/abbreviations.
 * @param {boolean} roundDecimal Flag to round decimals or not.
 * @returns {string} Abbreviated string.
 * @see `abbreviate` at js/helper.js
 */
const abbreviateForNewsroom = (num, roundDecimal = false) => {
  const number = numeral(num);
  if (number.value() >= 1000 || number.value() <= -1000) {
    if (roundDecimal) {
      return number.format('0a').toUpperCase();
    }
    let formatted = number.format('0.0a');
    if (formatted.indexOf('.0') >= 0) {
      formatted = number.format('0,0a');
    }
    return formatted.toUpperCase();

  } else if(num === undefined || number.value() === 0) {
    return '0';
  } else { // eslint-disable-line no-else-return
    return String(Math.round(num));
  }
};

export {
  abbreviateForChart,
  abbreviateForNewsroom
};
